import { z } from 'zod';
import { ProductionStatusFilterSchema } from '@/features/stacktrace/productions/-constants';
import { ProductionStatus as PS, ReleaseLevel } from '@/features/stacktrace/productions/-query/type';
import { ProductionTableColumns } from './-table/type';
const releaseLevelValues = Object.values(ReleaseLevel) as [ReleaseLevel, ...ReleaseLevel[]];

/**
 * プロダクション 一覧画面の URL search スキーマ。
 *
 * - status:        ステータスタブ用フィルタ ("ALL" + 4 ドメイン値)
 * - productId:     製品ドロップダウンフィルタ
 * - releaseLevels: リリースレベルの複数選択フィルタ (既定: 空配列)
 *                  空配列は「全レベル表示」(制約なし)
 * - freeText:      名称検索 (release.name / product.name 部分一致)
 * - pageIndex:     0-origin ページ番号
 * - pageSize:      1 ページあたりの件数
 * - sortColumn:    ソート対象カラム (既定: リリース予定日)
 * - orderDirection ソート方向 (既定: 降順)
 */
export const ProductionListPageFilterSchema = z.object({
  status: ProductionStatusFilterSchema.default(PS.IN_PROGRESS),
  productId: z.string().optional(),
  releaseLevels: z.array(z.enum(releaseLevelValues)).default([]),
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(ProductionTableColumns).default(ProductionTableColumns.PLANNED_RELEASE_DATE),
  orderDirection: z.enum(['asc', 'desc']).default('desc')
});